import limitService from "@/services/limit";

/**
 * Mixin for pages that render a limits table.
 * Requires on the host component:
 *   data: allLimits, editingLimit, configDialog
 *   methods: loadLimits(), canEditLimit(item), showErrorSnackbar(), showSuccessSnackbar()
 */
export default {
  methods: {
    async handleLimitCreated(limit) {
      await this.loadLimits();
      this.editingLimit = limit;
      this.configDialog = true;
    },

    async deleteLimit(item) {
      if (!this.canEditLimit(item)) {
        this.showErrorSnackbar(this.$t("limit_not_editable_in_company"));
        return;
      }
      const confirmed = await this.$confirm(this.$t("confirm_delete_limit"));
      if (!confirmed) return;

      try {
        await limitService.deleteLimit(item.id);
        this.allLimits = this.allLimits.filter((l) => l.id !== item.id);
        this.showSuccessSnackbar(this.$t("limit_deleted_successfully"));
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_deleting_limit"));
      }
    },

    async toggleLimitState(item) {
      if (!this.canEditLimit(item)) {
        this.showErrorSnackbar(this.$t("limit_not_editable_in_company"));
        return;
      }
      try {
        await limitService.toggleLimitState(item.id, item.state);
        this.showSuccessSnackbar(
          item.state === "active"
            ? this.$t("limit_activated")
            : this.$t("limit_deactivated")
        );
      } catch (error) {
        this.showErrorSnackbar(this.$t("error_changing_limit_status"));
        item.state = item.state === "active" ? "inactive" : "active";
      }
    },
  },
};
